module.exports = __webpack_public_path__ + "static/logo-2064c9f03857481acc90ba186e52ec12.png";